import { GRAPHQL_INTERNAL_URL } from '@/shared/constants'
import { ApolloClient, HttpLink, InMemoryCache } from '@apollo/client'
import { createPersistedQueryLink } from '@apollo/client/link/persisted-queries'

const sha256 = async (val: string): Promise<string> => {
  const encoder = new TextEncoder()
  const data = encoder.encode(val)
  const hashBuffer = await crypto.subtle.digest('SHA-256', data)
  const hashArray = Array.from(new Uint8Array(hashBuffer))
  return hashArray.map(b => b.toString(16).padStart(2, '0')).join('')
}

const linkChain = createPersistedQueryLink({
  sha256,
  useGETForHashedQueries: true
}).concat(
  new HttpLink({
    uri: GRAPHQL_INTERNAL_URL
  })
)

const client = new ApolloClient({
  ssrMode: true,
  link: linkChain,
  cache: new InMemoryCache()
})

interface QueryOptions {
  token?: string
  fetchPolicy?: string
}

export default async function queryGraphql(
  query: any,
  variables: any = {},
  options: QueryOptions = {}
) {
  const { token, fetchPolicy }: any = options
  try {
    return await client.query({
      query,
      variables,
      fetchPolicy: fetchPolicy || 'no-cache',
      context: { headers: { Authorization: token || '' } }
    })
  } catch (error: any) {
    console.log({
      msg: error?.message,
      name: query?.definitions?.[0]?.name?.value,
      status: error?.networkError?.statusCode || error?.networkError?.result,
      variables
    })
    const graphQLError: any = new Error()

    // Copy all properties from original error
    Object.assign(graphQLError, error)

    // Add additional useful properties
    graphQLError.message = error?.message || 'GraphQL query failed'
    graphQLError.data = error?.networkError?.result || error?.graphQLErrors?.[0]?.extensions
    graphQLError.status = error?.networkError?.statusCode || 500
    graphQLError.queryName = query?.definitions?.[0]?.name?.value
    graphQLError.variables = variables

    // Preserve original stack trace
    graphQLError.stack = error.stack
    throw graphQLError
  }
}
